import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAuth } from '@labrav/react-components'
import type { AppScope } from './authorizationModel'

type AuthorizationScopesState = {
  authorization: {
    scopes: AppScope[]
  }
}

/**
 * Keeps AuthPolicyProvider scopes in sync with the Redux authorization slice
 * (e.g. after hydrateAuthorizationClaims). Must render inside AuthPolicyProvider
 * and Redux Provider.
 */
export const AuthorizationScopesSync = () => {
  const scopes = useSelector(
    (state: AuthorizationScopesState) => state.authorization.scopes
  )
  const { setScopes } = useAuth()

  useEffect(() => {
    setScopes(scopes)
  }, [scopes, setScopes])

  return null
}
